import clsx from "clsx"
import { Children, ReactNode } from "react"
import './MessageCard.css'

type MessageCardProps= {
    children : ReactNode,
    fromSender:boolean,
    className:string
}

export const MessageCard = ({children, fromSender, className}:MessageCardProps)=>{
    return (
        <div className={clsx("message-cont mt-2 mb-2 w-100 " + className, 
        {"bgSender" : fromSender},
        {"bgRecipient" : !fromSender}
        )}>
            <div className="message-row">
                {children}
            </div>
        </div>
    )
}